module.exports = __webpack_public_path__ + "d1585fdf351c0bcd56a04ab460d51b3c.svg";